import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import { GiftCouponByCode, GiftCouponForPublic, GiftCouponForStore } from './giftCoupon.interface';

// 코드로 쿠폰 조회 (public)
export const giftCouponByCodeStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftCouponByCodeStatusAtomFamily',
  default: 'idle',
});

export const giftCouponByCodeDataAtomFamily = atomFamily<GiftCouponByCode | null, string>(
  {
    key: 'giftCouponByCodeDataAtomFamily',
    default: null,
  },
);

// ID로 쿠폰 조회 (public)
export const giftCouponByIdStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftCouponByIdStatusAtomFamily',
  default: 'idle',
});

export const giftCouponByIdDataAtomFamily = atomFamily<
  GiftCouponForPublic | null,
  string
>({
  key: 'giftCouponByIdDataAtomFamily',
  default: null,
});

// 교환 신청된 쿠폰 목록 조회 (seller/admin)
export const giftCouponRedemptionListStatusAtom = atom<QueryStatus>({
  key: 'giftCouponRedemptionListStatusAtom',
  default: 'idle',
});

export const giftCouponRedemptionListDataAtom = atom<GiftCouponForStore[]>({
  key: 'giftCouponRedemptionListDataAtom',
  default: [],
});
